import api from './api';

const RedemptionService = {
  async listVouchers(params = {}) {
    const { data } = await api.get('/redemptions/vouchers', { params });
    return { data: data.data, meta: data.meta };
  },

  async redeemVoucher(voucherId, billFile) {
    const formData = new FormData();
    if (billFile) formData.append('bill', billFile);
    const { data } = await api.post(`/redemptions/vouchers/${voucherId}/redeem`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data.data;
  },

  async submitRedemption(amount, billFile) {
    const formData = new FormData();
    formData.append('amount', amount);
    if (billFile) formData.append('bill', billFile);
    const { data } = await api.post('/redemptions/bill', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data.data;
  },

  async listRedemptions(params = {}) {
    const { data } = await api.get('/redemptions', { params });
    return { data: data.data, meta: data.meta };
  },

  async requestPayout(amount, chequeFile) {
    const formData = new FormData();
    formData.append('amount', amount);
    if (chequeFile) formData.append('cheque', chequeFile);
    const { data } = await api.post('/redemptions/payout', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data.data;
  },

  async listPayouts(params = {}) {
    const { data } = await api.get('/redemptions/payouts', { params });
    return { data: data.data, meta: data.meta };
  },
};

export default RedemptionService;
